export default __webpack_public_path__ + "static/media/04_DAIF_Infra_01_02-end.f736d534.jpg";